import Foryou from "../images/news1.jpg";
import RIPLEGEND from "../images/covid.jpeg";


var foryouData = {
  headlines: {
    img: {Foryou},
    subTitle: "News · 2 hours ago",
    Title: "Monkeypox virus: मंकीपॉक्स वायरस से बचाव के उपाय"

  },
  tweets: [{
    subhead: "COVID-19 · LIVE",
    title: "COVID-19 in India",
    img: {RIPLEGEND}
  },
  {
    subhead: "India national news · LIVE",
    title: "देश में COVID-19 के नए केसों में बढ़ोतरी"
  },
  {
    subhead: "NewsBytes · June 1, 2022",
    title: "No concerning trends caused by new Omicron subvariants: Experts",
    img: {RIPLEGEND}
  },
  {
    subhead: "Bloomberg Quicktake · June 1, 2022",
    title: "Shanghai residents experience freedom after 2 months of lockdown"
  }]
};
export default foryouData;
